import ValidateField from "../../hooks/useValid";
import { ValidateMessages } from "../../constants/ValidateConstants";
import { ValidateName } from "../../constants/ValidateNameConstants";

export default function validation(values, facilityData) {
  const errors = {};
  const facilities = Array.isArray(facilityData) ? facilityData : [];
  const sameCode = facilities.find(
    (item) =>
      item?.facilityCode?.trim()?.toLowerCase() ===
        values?.facilityCode?.trim()?.toLowerCase() &&
      item?.id !== values?.id
  );
  const sameName = facilities.find(
    (item) =>
      item?.facilityName?.trim()?.toLowerCase() ===
        values?.facilityName?.trim()?.toLowerCase() &&
      item?.id !== values?.id
  );

  errors.facilityCode = ValidateField(
    values.facilityCode,
    "Facility code",
    "Facility code",
    [ValidateName?.REQUIRED]
  );

  errors.facilityName = ValidateField(
    values.facilityName,
    "Facility name",
    "Facility name",
    [ValidateName?.REQUIRED]
  );

  errors.country = ValidateField(
    values.countryId,
    ValidateName?.COUNTRY,
    ValidateName?.COUNTRY,
    [ValidateName?.REQUIRED]
  );

  errors.company = ValidateField(
    values.companyId,
    ValidateName?.COMPANY_NAME,
    ValidateName?.COMPANY_NAME,
    [ValidateName?.REQUIRED]
  );

  errors.address = ValidateField(
    values.address,
    ValidateName?.ADDRESS,
    ValidateName?.ADDRESS,
    [ValidateName?.REQUIRED]
  );

  if (sameCode) {
    errors.facilityCode = "Facility code already exists";
  }

  if (sameName) {
    errors.facilityName = "Facility name already exists";
  }

  if (!values?.facilityCode && !values?.facilityName) {
    errors.facilityerr = ValidateMessages?.SHOULD_SAME_FIELD_NAME("facility");
  }

  return Object.keys(errors).reduce((acc, key) => {
    if (errors[key] !== undefined) acc[key] = errors[key];
    return acc;
  }, {});
}
